module.exports = __webpack_public_path__ + "img/symbol_7.8a54da30.png";